import React, { useState } from 'react';
import clsx from "clsx";

export default class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      open: false,
    };
  };

  render(){
    
    return(
      <div className='tabs-wrapper' onClick={this.clickTabWrapper}>
        {this.props.displayErrorMessage ? <div className="alert alert-danger">{I18n.t('there_were_errors')}</div> : null}
        <ul className="nav nav-tabs" role="tablist">
          {this.renderTabs()}
        </ul>
      </div>
    );
  };

  renderTabs(){
    return (this.props.tabs.map((tab) =>{
      var itemClases = this.tabStyles(tab)

      return(
        <li className={itemClases} key={tab.tabName}>
          <a className={tab.classes ? "nav-link " + tab.classes : "nav-link"} href={tab.href ? tab.href : "#" + tab.targetName} name={tab.targetName} onClick={() => this.changeTab(tab)}>
            {tab.tabName}
            {tab.labelCount ? ` (${tab.labelCount})` : null}
            {tab.tabErrorCount ? <span className="badge danger">{tab.tabErrorCount}</span> : null}
          </a>
          {this.renderDropDownCarrot(tab)}
        </li>
        );
      })
    );
  };

  renderDropDownCarrot = (tab) => {
    if (!this.state.open && tab.classes && tab.classes.includes('active')){
      return(
        <span className="arrow-right"></span>
      );
    } else if (this.state.open && tab.classes && tab.classes.includes('active')){
      return (
        <span className="arrow-down"></span>
      );
    };
  };

  tabStyles = (tab) =>{
    if (!this.state.open){
      return clsx({
        'hidden': tab.classes && tab.classes.includes('active') ? false : true,
        'flexed content-space-between': tab.classes && tab.classes.includes('active') ? true : false,
        'nav-item': true,
        'superadmin-tool': tab.classes && tab.classes.includes('superadmin-tool') ? true : false,
      });
    } else if(this.state.open){
      return clsx({
        'priority-slot': tab.classes && tab.classes.includes('active') ? true : false,
        'secondary-slots': tab.classes && tab.classes.includes('active') ? false : true,
        'nav-item': true,
        'superadmin-tool': tab.classes && tab.classes.includes('superadmin-tool') ? true : false,
      });
    } 
    // else {
    //   return clsx({
    //     'nav-item': true
    //   });
    // };
  };

  clickTabWrapper = () => {
    if(!this.state.open){
      this.setState({open: true});
    };
  };

  changeTab = (tab) => {
    tab.changeHandler(tab.targetName);
    this.setState({open: false});
  };

};
